<template>
	<div>
		<div>
			广告显示效果<el-tooltip placement="top" v-if="tips">
				<div slot="content" class="tipcontent">
					<div v-html="tips" class="info"></div>
				</div>
				<ig-icon name="tishi" class="infopointer"></ig-icon>
			</el-tooltip>
		</div>
		<div class="preview">
			<div class="text">
				广告 · <span @click="toJump">{{ domain }}</span>
			</div>
			<div class="title font layout">{{ title }}</div>
			<div class="text minifont">{{ explain }}</div>
			<div class="text minifont layout">{{ structed }}</div>
			<div class="title minifont page_box">
				<div class="page" v-for="(item, index) in webpageList" :key="index">
					<div>{{ item.showText }}</div>
					<div class="explain">{{ item.explain1 }}</div>
					<div class="explain">{{ item.explain2 }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['domain', 'adTitleList', 'adExplainList', 'propagandalist', 'webpageList'],
	data() {
		return {
			tips: '此预览画面展现了使用您的素材资源可能会制作出什么样的广告。并非所有内容都会显示出来。<br/>素材资源可能会以任意顺序展示，因此请确保它们无论是单独使用还是组合使用都行得通。<br/>实际展示的广告最多可能会显示 3 个标题、2 条广告说明；此外，附加信息不一定会随广告展示',
		};
	},

	components: {},

	computed: {
		title() {
			let arr = [];
			if (typeof this.adTitleList == 'string') {
				arr = this.adTitleList;
			} else {
				if (this.adTitleList && this.adTitleList.length) {
					
					this.adTitleList.forEach(e => {
				       
						arr.push( this.strFilter(e.content));
					});
				}
			}

			return arr.length ? arr.toString().replace(/,/g, ' | ') : '';
		},
		explain() {
			let arr = [];
			if (typeof this.adExplainList == 'string') {
				arr = this.adExplainList;
			} else {
				if (this.adExplainList && this.adExplainList.length) {
					this.adExplainList.forEach(e => {
						arr.push(e.content);
					});
				}
			}

			return arr.length ? arr.toString().replace(/,/g, '。') : '';
		},
		structed() {
			let arr = [];
			if (typeof this.propagandalist == 'string') {
				arr = this.propagandalist;
			} else {
				if (this.propagandalist && this.propagandalist.length) {
					this.propagandalist.forEach(e => {
						arr.push(e.content);
					});
				}
			}
			return arr.length ? arr.toString().replace(/,/g, '，') : '';
		},
	},

	methods: {
		strFilter(value)
		{
			let reg = /{(keyword:|KeyWord:|Keyword:).+?}/g;
			let val=value;
			let matchValue = value.match(reg);
			if ( matchValue && matchValue.length) {
				matchValue.forEach(element => {
					let str = element.substr(9);
					str = str.slice(0, str.length - 1);
					val = val.replace(element, str);
				});
			}
			return val;
		},
		toJump() {
			window.open(this.domain);
		},
	},
};
</script>

<style lang="scss" scoped>
.info {
	line-height: 20px;
	font-size: 12px;
}
.infopointer {
	cursor: pointer;
	font-size: 12px;
	margin-left: 5px;
}
.preview {
	margin-top: 20px;
	padding: 20px;
	background: #ffffff;
	box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.1);
	border-radius: 2px;
	.title {
		font-weight: 500;
		color: #1a0dab;
		font-size: 18px;
		margin: 5px 0px;
		word-break: break-all;
	}
	.text {
		font-weight: 400;
		color: #999999;
		word-break: break-all;
	}
	.minifont {
		font-size: 12px;
	}
	.font {
		font-size: 14px;
	}
	.layout {
		padding-bottom: 3px;
	}
	.page_box {
		display: grid;
		grid-template-columns: repeat(2, 44%);
		gap: 20px;
		.explain {
			color: #999999;
		}
	}
}
</style>
